import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import FroalaEditorRSD from "../../Uitls/FroalaEditorRSD";
import DisabledImage from "../../images/DisabledTick1.svg";
import {
  convertTextToBullets,
  extractListItemsAsText,
} from "../../Uitls/EditorUtil";

const Frame = ({
  frameId,
  time,
  onSelect,
  isSelected,
  description,
  onDescriptionChange,
  imgSrc,
  width,
  activeTab,
  currentMLRStatus,
  tabSelected,
  trackChangesNotes,
  onTrackChange,
  newImgSrc,
  imgChanged,
}) => {
  const maxCharsMap = {
    120: 40,
    160: 50,
    180: 70,
    250: 100,
    300: 100,
    320: 100,
    468: 180,
    728: 300,
    768: 300,
  };

  let maxChars = maxCharsMap[width] || 40;

  const heightFromSize = (() => {
    if (!activeTab) return 100;
    const parts = activeTab.split("×");
    if (parts.length === 2) {
      return parseInt(parts[1].trim(), 10) || 100;
    }
    return 100;
  })();
  const widthFromSize = (() => {
    if (!activeTab) return 100;
    const parts = activeTab.split("×");
    if (parts.length === 2) {
      return parseInt(parts[0].trim(), 10) || 100;
    }
    return 100;
  })();

  const getTextCharCount = (html) => {
    if (!html) return 0;
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return (temp.textContent || temp.innerText || "").length;
  };

  const [displayCharCount, setDisplayCharCount] = useState(
    getTextCharCount(description || ""),
  );

  useEffect(() => {
    if (!isSelected) {
      setDisplayCharCount(0);
    } else {
      setDisplayCharCount(getTextCharCount(description || ""));
    }
  }, [description, isSelected, activeTab]);

  const handleModelChange = (newText) => {
    const charCount = getTextCharCount(newText);
    setDisplayCharCount(charCount);

    if (charCount > maxChars) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = newText;
      let textContent = tempDiv.textContent || tempDiv.innerText || "";
      newText = textContent.substring(0, maxChars);
      tempDiv.innerText = newText;
      newText = tempDiv.innerHTML;
      toast.error(
        <div className="notificationText">{`Maximum characters limit exceeded.`}</div>,
      );
    }

    onDescriptionChange(frameId, newText);
  };

  const handleTrackModelChange = (newText) => {
    const updatedTrackChanges = extractListItemsAsText(newText);
    onTrackChange(frameId, updatedTrackChanges);
  };

  return (
    <div
      className="frame-wrapper mb-3"
      style={{ display: "flex", alignItems: "center" }}
    >
      {tabSelected === 1 &&
        (currentMLRStatus !== "Not Submitted" ? (
          <img
            style={{
              marginRight: "14px",
              cursor:
                currentMLRStatus !== "Not Submitted"
                  ? "not-allowed"
                  : "pointer",
            }}
            className=""
            src={DisabledImage}
            width="21"
            height="21"
            alt="tick"
          />
        ) : (
          <input
            type="checkbox"
            checked={currentMLRStatus !== "Not Submitted" ? true : isSelected}
            disabled={false}
            onChange={() => onSelect(frameId)}
            className="frame-checkbox"
            style={{
              marginRight: "14px",
              cursor:
                currentMLRStatus !== "Not Submitted"
                  ? "not-allowed"
                  : "pointer",
            }}
          />
        ))}
      <div style={{ width: "100%" }}>
        <div
          className="frame-container"
          style={{
            display: "flex",
            width: "100%",
            gap: "20px",
          }}
        >
          {/* Frame Box */}
          <div
            className="frame-box"
            style={{
              flex: "1",
              display: "flex",
              flexDirection: "column",
              border: "1px solid #e2e2e2",
              borderRadius: "6px",
              backgroundColor: "#fff",
              overflow: "hidden",
            }}
          >
            {/* Frame Header */}
            <div
              className="frame-header"
              style={{
                padding: "10px 15px",
                borderBottom: "1px solid #f0f0f0",
                display: "flex",
                alignItems: "center",
                fontSize: "14px",
              }}
            >
              <span
                className="frame-id"
                style={{ fontWeight: "bold", color: "#1e1e1e" }}
              >
                {time === 10000 ? "Scroll Component" : `FRAME ${time + 1}`}
              </span>
              <div
                className="separator"
                style={{
                  width: "1.5px",
                  height: "17px",
                  backgroundColor: "#6a62623d",
                  opacity: 0.5,
                  margin: "0 7px",
                }}
              ></div>
              <span className="frame-time">
                {time !== 10000 && (
                  <span>
                    Time: <strong>{time}s</strong>
                  </span>
                )}
              </span>
            </div>

            {tabSelected === 2 && imgChanged && (
              <div
                style={{
                  paddingLeft: "15px",
                  marginTop: "16px",
                  marginBottom: "-10px",
                }}
              >
                <div
                  style={{
                    backgroundColor: "#F2F3F3",
                    height: "24px",
                    width: "50px",
                    fontWeight: "600",
                    fontSize: "14px",
                    borderRadius: "4px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Old
                </div>
              </div>
            )}
            {/* Frame Image Content */}
            <div
              className="frame-image"
              style={{
                flex: 1,
                padding: "15px",
                cursor: currentMLRStatus !== "Not Submitted" ? "" : "pointer",
              }}
              onClick={
                currentMLRStatus !== "Not Submitted"
                  ? () => {}
                  : () => onSelect(frameId)
              }
            >
              {imgSrc && imgSrc.startsWith("data:image/png;base64,") ? (
                <img
                  src={imgSrc}
                  alt={`Frame ${frameId}`}
                  className="preview-image"
                  style={{
                    maxWidth: `${widthFromSize}px`,
                    maxHeight: time === 10000 ? "none" : `${heightFromSize}px`,
                    objectFit: "contain",
                  }}
                />
              ) : (
                <div
                  style={{
                    width: "300px",
                    height: "200px",
                    backgroundColor: "#7BAEB8",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <p style={{ color: "#fff" }}>Preview Image</p>
                </div>
              )}
            </div>
            {tabSelected === 2 && imgChanged && (
              <div style={{ paddingLeft: "15px", marginBottom: "-10px" }}>
                {" "}
                <div
                  style={{
                    backgroundColor: "#FFEAB4",
                    height: "24px",
                    width: "50px",
                    fontWeight: "600",
                    fontSize: "14px",
                    borderRadius: "4px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  New
                </div>
              </div>
            )}
            {tabSelected === 2 && imgChanged && (
              <div
                className="frame-image"
                style={{
                  flex: 1,
                  padding: "15px",
                }}
              >
                {newImgSrc && newImgSrc.startsWith("data:image/png;base64,") ? (
                  <img
                    src={newImgSrc}
                    alt={`Frame ${frameId}`}
                    className="preview-image"
                    style={{
                      maxWidth: `${widthFromSize}px`,
                      maxHeight:
                        time === 10000 ? "none" : `${heightFromSize}px`,
                      objectFit: "contain",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "300px",
                      height: "200px",
                      backgroundColor: "#7BAEB8",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ color: "#fff" }}>Preview Image</p>
                  </div>
                )}
              </div>
            )}
            <div
              className="description-box"
              style={{
                width: "100%",
                borderTop: "1px solid #e6e6ec",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                maxHeight: "80px",
              }}
            >
              <div
                className="description-header"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 15px",
                  paddingBottom: "0px",
                }}
              >
                <div
                  className="description-label"
                  style={{ fontSize: "12px", color: "#54565b" }}
                >
                  Animation Note
                </div>
              </div>
              <div
                className="description-content"
                style={{
                  overflow: "auto",
                  paddingTop: "0px",
                }}
              >
                {(currentMLRStatus !== "Not Submitted" || isSelected) && (
                  <FroalaEditorRSD
                    placeHolder="Type here..."
                    isDisabled={false}
                    handleModelChange={handleModelChange}
                    className="froalaContent-editor-rsd feSampleRsd customScrollBar rsdTrackScroll"
                    defaultText={
                      time === 10000
                        ? "This ISI/PI section will scroll up when the other animation are finished."
                        : description || ""
                    }
                    tag="textarea"
                    showToolBar={false}
                    maxChars={maxChars}
                    getTextCharCount={getTextCharCount}
                    setDisplayCharCount={setDisplayCharCount}
                  />
                )}
              </div>
            </div>
            {tabSelected === 2 && (
              <div
                className="description-box"
                style={{
                  width: "100%",
                  borderTop: "1px solid #e6e6ec",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  maxHeight: "80px",
                }}
              >
                <div
                  className="description-header"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px 15px",
                    paddingBottom: "0px",
                  }}
                >
                  <div
                    className="description-label"
                    style={{ fontSize: "12px", color: "#54565b" }}
                  >
                    Track Changes
                  </div>
                </div>
                <div
                  className="description-content-track"
                  style={{
                    marginLeft: "17px",
                  }}
                >
                  {(currentMLRStatus !== "Not Submitted" || isSelected) && (
                    <FroalaEditorRSD
                      placeHolder="Type here..."
                      handleModelChange={handleTrackModelChange}
                      isDisabled={false}
                      className="froalaContent-editor-rsd feSampleRsd customScrollBar rsdTrackScroll"
                      defaultText={
                        imgChanged
                          ? typeof trackChangesNotes === "object"
                            ? convertTextToBullets("", trackChangesNotes)
                            : convertTextToBullets(trackChangesNotes || "")
                          : `<div style="padding-top:5px;padding-bottom:5px;margin-left:-3px">No Changes</div>`
                      }
                      tag="textarea"
                      showToolBar={false}
                      maxChars={maxChars}
                      getTextCharCount={getTextCharCount}
                      setDisplayCharCount={setDisplayCharCount}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Frame;
